import Cookies from 'js-cookie';

export default {
    name: 'ScoreBoard',
    props: {
        msg: String
    },
    data() {
        return {
            items: [],
            points: [],
            curernt_point: 0,
            game_name: ""
        }
    },
    mounted() {
        this.loadDataCookis();
    },
    methods:
    {
        async loadData() {
            try {
                const response = await fetch('data.json');
                const data = await response.json();
                this.items = data.stats.points;
                this.points = data.points
                this.game_name = data.stats.game_name;
            } catch (error) {
                console.error('Błąd podczas ładowania danych:', error);
            }
        },
        pointClick(value) {
            console.log(value);
            this.curernt_point = this.curernt_point + value;
            console.log(this.curernt_point);
        },
        userClick(user_id) {
            if (this.curernt_point != 0) {
                const item = this.items.find(item => item.user_id === user_id);
                if (item) {
                    item.point = item.point + this.curernt_point;
                    item.last_point = '[' + this.curernt_point + '] ' + item.last_point;
                    this.saveData();
                    this.curernt_point = 0;
                }
                console.log(this.items);
            }
        },
        saveData() {
            Cookies.set('pointsJson', JSON.stringify(this.points), { expires: 7 });
            Cookies.set('itemsJson', JSON.stringify(this.items), { expires: 7 });
            console.log('Data saved to cookie!');
        },
        loadDataCookis() {
            const points1 = Cookies.get('pointsJson');
            const items1 = Cookies.get('itemsJson');
            console.log(points1);
            console.log(items1);
            if (points1 == null || items1 == null) {
                this.loadData();
            }
            else {
                if (Object.keys(points1).length > 0 & Object.keys(items1).length > 0) {
                    this.points = JSON.parse(points1);
                    this.items = JSON.parse(items1);
                    console.log(this.points);
                    console.log(this.items);
                    console.log('Data loaded to cookie!');
                } else {
                    console.log('Data no loaded to cookie!');
                    this.loadData();
                }
            }
        },
        deleteCookie() {
            Cookies.remove('pointsJson');
            Cookies.remove('itemsJson');
        }

    }
}